export default __webpack_public_path__ + "static/media/330_portfolio04-es-mobile.a8539017.png";